import type { FC } from 'react';

import { motion } from 'framer-motion';
import { Wifi, WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '../lib/utils';

interface ConnectionStatusProps {
  isConnected: boolean;
  latency: number | undefined;
}

export const ConnectionStatus: FC<ConnectionStatusProps> = ({ 
  isConnected, 
  latency 
}) => {
  const { t } = useTranslation('layout');

  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        {isConnected ? (
          <Wifi className="text-green-500" size={16} />
        ) : (
          <WifiOff className="text-red-500" size={16} />
        )}
        <motion.div
          className={cn(
            "absolute -top-1 -right-1 w-2 h-2 rounded-full",
            isConnected ? "bg-green-500" : "bg-red-500"
          )}
          animate={isConnected ? {
            scale: [1, 1.5, 1],
            opacity: [1, 0.5, 1],
          } : {}}
          transition={{
            duration: 2,
            repeat: Infinity,
          }}
        />
      </div>
      <div className="text-xs">
        <div className={cn(
          "font-medium",
          isConnected ? "text-green-500" : "text-red-500"
        )}>
          {isConnected ? t('connection.connected') : t('connection.reconnecting')}
        </div>
        {isConnected && latency !== undefined && (
          <div className="text-muted-foreground">
            {latency}ms
          </div>
        )}
      </div>
    </div>
  );
};
